import { format } from 'date-fns';

// Build a local Date from a YYYY-MM-DD string using its parts, so display never shifts a day due to
// UTC parsing (`new Date('2026-06-01')` is midnight UTC and can render as the previous day locally).
export const parseIsoDate = (value: string): Date => {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, (month ?? 1) - 1, day ?? 1);
};

export const formatIsoDate = (value: string, dateFormat = 'dd MMM yyyy'): string =>
  value ? format(parseIsoDate(value), dateFormat) : '';

export const toIsoDate = (date: Date): string => format(date, 'yyyy-MM-dd');
